import { CellErrors, CellPosition, EntityIdToName } from '../../types';
import { convertPositionToArea, isAreaInsideArea } from '../area/area';
import { getSheetNameFromId } from '../sheet/metaData';
import { convertParsedAddressToArea } from './address';
import { parseFormulaAddresses } from './formulaAddress';
import { parseSingleAddress } from './singleAddress';

export const CellErrorsMessages = {
  SheetName: `${CellErrors.REF}:Unresolved sheet name`,
  CircularDep: `${CellErrors.REF}:Circular dependency detected`,
};

export const replaceSheetNamesWithId = (
  formula: string,
  sheetsIdToName: EntityIdToName
) => {
  // if (!doesCellContainsFormula(formula)) return formula;
  if(formula.startsWith('=')) return formula

  const tokens = parseFormulaAddresses(formula);
  for (const token of tokens) {
    if (token.includes('!')) {
      const [refSheetId, adr] = token.split('!');

      const sheetName =
        refSheetId.startsWith("'") && refSheetId.endsWith("'")
          ? refSheetId.substring(1, refSheetId.length - 1)
          : refSheetId;

      const sheetId = getSheetIdFromSheetName(sheetsIdToName, sheetName);
      if (sheetId) {
        formula = formula.replaceAll(token, `'${sheetId}'!${adr}`);
      }
      sheetName.toLowerCase();
    }
  }

  return formula;
};

export const validateFormulaForCell = (
  cellPosition: CellPosition,
  formula: string,
  sheetsIdToName: EntityIdToName,
  maxColIndex: number,
  maxRowIndex: number
) => {
  let error: string | undefined;
  const tokens = parseFormulaAddresses(formula);
  for (const token of tokens) {
    if (token.includes('!')) {
      const [refSheetId, adr] = token.split('!');

      if (isCircularDependency(adr, cellPosition, maxColIndex, maxRowIndex)) {
        error = CellErrorsMessages.CircularDep;
        break;
      }

      const sheetId =
        refSheetId.startsWith("'") && refSheetId.endsWith("'")
          ? refSheetId.substring(1, refSheetId.length - 1)
          : refSheetId;

      const sheetName = getSheetNameFromId(sheetId, sheetsIdToName);

      if (!sheetName) {
        error = `${CellErrorsMessages.SheetName} '${sheetName}' `;
        break;
      }
    } else {
      if (isCircularDependency(token, cellPosition, maxColIndex, maxRowIndex)) {
        error = CellErrorsMessages.CircularDep;
        break;
      }
    }
  }

  return error;
};

const isCircularDependency = (
  address: string,
  cellPosition: CellPosition,
  maxColIndex: number,
  maxRowIndex: number
) => {
  const area = convertParsedAddressToArea(
    parseSingleAddress(address),
    maxColIndex,
    maxRowIndex
  );
  const cellArea = convertPositionToArea(cellPosition);

  return isAreaInsideArea(cellArea, area);
};

export const getSheetIdFromSheetName = (
  sheetsIdToName: EntityIdToName,
  sheetName: string
) =>
  Object.keys(sheetsIdToName).find(
    (key) => sheetsIdToName[key].toLowerCase() === sheetName.toLowerCase()
  );
